import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Fieldset from '@/components-latest/layout/Fieldset'
import Separator from '@/components-latest/primitives/Separator'
import { InputField, NumericField } from '@/components-latest/shared/Form'
import { IEditMenuItemFormData } from '@/components-latest/ui/MenuPage/EditMenuItemModal'
import { selectCurrencyCode } from '@/ducks/store/selectors/store.selectors'

import Styles from './EditMenuItemDetails.module.scss'

type Props = {
  isLoading: boolean
  form: UseFormReturn<IEditMenuItemFormData>
}

const EditMenuItemDetails = ({ isLoading, form }: Props) => {
  const { t } = useTranslation()
  const currency = useSelector(selectCurrencyCode) || ''

  const {
    control,
    formState: { errors },
    setError
  } = form

  const cleanFieldErrorCreator =
    (fieldName: keyof IEditMenuItemFormData) => () => {
      setError(fieldName, { message: '' })
    }

  return (
    <>
      <Fieldset
        variant="nextBody"
        weight="semiBold"
        label={t('menu.edit-modal.item-name')}>
        <InputField
          data-testid="menu-item-form-food_name"
          data-error={!!errors.food_name?.message}
          name="food_name"
          intent={errors.food_name?.message ? 'negative' : 'default'}
          control={control}
          onFocus={cleanFieldErrorCreator('food_name')}
          disabled={isLoading}
        />
      </Fieldset>
      <Separator />
      <Fieldset
        flexDirection="row"
        label={t('menu.edit-modal.price', { currency: currency })}>
        <NumericField
          data-testid="menu-item-form-price"
          className={Styles.numericInput}
          disabled={isLoading}
          data-error={!!errors.price?.message}
          intent={errors.price?.message ? 'negative' : 'default'}
          onFocus={cleanFieldErrorCreator('price')}
          name="price"
          control={control}
        />
      </Fieldset>
      <Separator />
      <Fieldset flexDirection="row" label={t('menu.edit-modal.maxQuantity')}>
        <NumericField
          data-testid="menu-item-form-maxQuantity"
          data-error={!!errors.maxQuantity?.message}
          className={Styles.numericInput}
          disabled={isLoading}
          intent={errors.maxQuantity?.message ? 'negative' : 'default'}
          onFocus={cleanFieldErrorCreator('maxQuantity')}
          name="maxQuantity"
          control={control}
        />
      </Fieldset>
    </>
  )
}

export default EditMenuItemDetails
